import React from 'react';
import Navbar from '../Navbar';
import AboutUs from '../AboutUs';
import Footer from '../Footer';

const About = () => {
  return (
    <div>
       <Navbar />
       <AboutUs />
       <Footer />
    </div>
  )
}

export default About;
